import langManager from "../../model/lang";

var DATE_FORMATS = {
  zh_CN: { ymd: "y年m月d日 ", md: "m月d日 " },
  zh_TW: { ymd: "y年m月d日 ", md: "m月d日 " },
  en_US: { ymd: "m/d/y ", md: "m/d " },
};

function getFormat() {
  return DATE_FORMATS[langManager.current] || DATE_FORMATS.zh_CN;
}

function applyTemplate(tpl, y, m, d) {
  return tpl.replace("y", y).replace("m", m).replace("d", d);
}

export function formatDate(value) {
  let date = new Date(parseInt(value) * 1000);
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return applyTemplate(getFormat().md, "", m, d);
}

export function formatDateNew(value) {
  let date = new Date(parseInt(value) * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  return applyTemplate(getFormat().ymd, y, m, d);
}

export function formatTime(value) {
  let date = new Date(parseInt(value) * 1000);
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? "0" + minute : minute;
  return h + ":" + minute;
}

export default {
  formatDate,
  formatDateNew,
  formatTime,
};
